<template>
  <div>
    <v-layout row justify-center>
      <v-select
        v-model="status_filter"
        :items="status_items"
        :label="$t('extracurriculares.courses.form.status')"
        clearable
      ></v-select>
      <v-autocomplete
        label="Curso"
        v-model="course_id"
        :items="courses_to_show"
        clearable
      ></v-autocomplete>
      <v-menu
        v-model="date_picker"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date"
            label="Fecha de asistencia desde"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="date" @input="date_picker = false"></v-date-picker>
      </v-menu>
      <v-menu
        v-model="date_picker_to"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="date_to"
            label="Fecha de asistencia hasta"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="date_to" @input="date_picker_to = false"></v-date-picker>
      </v-menu>
      <v-btn @click="getAssistance" color="primary">generar</v-btn>
    </v-layout>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="assistance"
        name="assistance.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="assistance"
        :search="search"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.date }}</td>
          <td class="text-xs-center">{{ props.item.course_id }}</td>
          <td class="text-xs-center">{{ props.item.course }}</td>
          <td class="text-xs-center">{{ props.item.schedule }}</td>
          <td class="text-xs-center">{{ props.item.student }}</td>
          <td class="text-xs-center">{{ props.item.gender }}</td>
          <td class="text-xs-center">{{ props.item.assist }}</td>
          <td class="text-xs-center">{{ props.item.enrrolled }}</td>
          <td class="text-xs-center">{{ props.item.notes }}</td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import JsonExcel from 'vue-json-excel'
  export default {
    name: 'report-assistance-view',
    components: {
      'download-excel': JsonExcel,
    },
    data() {
      return {
        headers: [
          { text: this.$t('extracurriculares.teachers_assistance.export.date'), align: 'center', value: 'date'},
          { text: this.$t('extracurriculares.teachers_assistance.export.course_id'), align: 'center', value: 'course_id'},
          { text: this.$t('extracurriculares.teachers_assistance.export.course'), align: 'center', value: 'course'},
          { text: this.$t('extracurriculares.teachers_assistance.export.schedule'), align: 'center', value: 'schedule'},
          { text: this.$t('extracurriculares.teachers_assistance.export.student'), align: 'center', value: 'student'},
          { text: this.$t('extracurriculares.teachers_assistance.export.gender'), align: 'center', value: 'gender'},
          { text: this.$t('extracurriculares.teachers_assistance.export.assist'), align: 'center', value: 'assist'},
          { text: this.$t('extracurriculares.teachers_assistance.export.enrrolled'), align: 'center', value: 'enrrolled'},
          { text: this.$t('extracurriculares.teachers_assistance.export.notes'), align: 'center', value: 'notes'},
        ],
        assistance: [],
        courses: [],
        courses_to_show: [],
        status_items: [
          { value: 1, text: 'Activo' },
          { value: 0, text: 'Inactivo' },
        ],
        search: '',
        status_filter: 1,
        date: '',
        date_to: '',
        course_id: '',
        date_picker: false,
        date_picker_to: false
      }
    },
    watch: {
      status_filter() {
        let courses_to_show = this.courses

        if (this.status_filter && this.status_filter !== '') {
          courses_to_show = courses_to_show.filter(course => course.status === this.status_filter)
        }

        this.courses_to_show = courses_to_show
      },
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('/api/extracurriculares/report/assistance/courses')
          .then(resp => {
            if (resp.status === 200) {
              resp.data.forEach(course => {
                this.courses.push({
                  value: course.id,
                  text: course.name,
                  status: course.status
                })
              });
            }
          })
          this.courses_to_show = this.courses
      },
      getAssistance() {
        let course_id = this.course_id
        let status = this.status_filter

        if (this.date == '') {
          return
        }

        if (this.date_to == '') {
          this.date_to = this.date
        }

        if (this.course_id == '') {
          course_id = 'todos'
        }

        if (this.status_filter == '') {
          status_filter = 'todos'
        }

        axios.get(`/api/extracurriculares/report/assistance/${this.date}/${this.date_to}/${course_id}/${status}`)
          .then(resp => {
            if (resp.status === 200 ) {
              this.assistance = resp.data
            }
          })
          .catch(error => console.log(error))


      },
      downloadAssistance() {

      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/reports/assistance.vue